import React from "react";

function CircleAndQuater() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 59 59">
      <circle cx="24.463" cy="34.537" r="24.463" fill="#D284FC"/>
      <path
    fill="#0068FF"
    fillOpacity="0.4"
    d="M59 34.537C59 15.463 43.537 0 24.463 0v34.537H59z"
    />
    </svg>
  );
}

export default CircleAndQuater;